// --------------------------------------------------------
// AGENDA DIA HORARIO LIST ITEM - AgendaDiaHorarioListItem
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useState } from 'react'
import moment from 'moment'
import Colors from '../../constants/Colors'
import { ReactComponent as TrashBin } from '../../assets/imgs/trashBin.svg'
import { ReactComponent as Block } from '../../assets/imgs/protectionLock.svg'
import { ReactComponent as Unblock } from '../../assets/imgs/protectionLockOpen.svg'
import { Text } from '../UI/generalLayout/Layout.styled';
import GenericModal from '../genericModal/GenericModal';
import { Tooltip } from '@mui/material';
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import AccessTimeIcon from '@mui/icons-material/AccessTime';


// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// AGENDA DIA HORARIO LIST ITEM INTERFACE
// --------------------------------------------------------

interface IAgendaDiaHorarioListItem {
    dateHour: any;
    index: number;
    onBlockHorario: () => void;
    onConfirmDeleteHorario: () => void;
    onVerAgenda?: () => void;
}
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AgendaDiaHorarioListItem = ({ dateHour, index, onBlockHorario, onConfirmDeleteHorario, onVerAgenda }: IAgendaDiaHorarioListItem) => {
    // --------------------------------------------------------
    // AGENDA DIA HORARIO LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const [showModalExcluirHorario, setShowModalExcluirHorario] = useState(false)

    const activeSlots = dateHour.slots?.filter((s: any) => !s.excluido) || [];
    const slotListString = activeSlots.map((s: any) => moment(s.horario).format('HH:mm')).join(', ');

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            {!isMobile ? (
                <div style={{ paddingLeft: 10, paddingRight: 10, backgroundColor: dateHour.inativo ? '' : Colors.GRAY50, marginBottom: 10, flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                    <Text color={Colors.SPM800} bold style={{ width: 200, opacity: dateHour.inativo ? '0.5' : '' }}>{dateHour.date}</Text>
                    <Text color={Colors.SPM800} style={{ opacity: dateHour.inativo ? '0.5' : '', width: 200 }} bold >{`${dateHour.horario.horarioInicial} - ${dateHour.horario.horarioFinal}`}</Text>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {!dateHour.inativo && onVerAgenda && (
                            <>
                                <Tooltip title={slotListString}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10, cursor: 'default' }}>
                                        <AccessTimeIcon style={{ fontSize: 18, color: Colors.SPM400, marginRight: 4 }} />
                                        <Text style={{ fontSize: 12, color: Colors.GRAY400 }}>{activeSlots.length}</Text>
                                    </div>
                                </Tooltip>
                                <Text color={Colors.SPM600} bold style={{ cursor: 'pointer', fontSize: 14 }} onClick={onVerAgenda}>
                                    VER AGENDA {'>'}
                                </Text>
                            </>
                        )}
                    </div>
                    <div style={{ width: 100, display: 'flex', justifyContent: 'center' }}>
                        <Tooltip title={dateHour.inativo ? 'Desbloquear' : 'Bloquear'}>
                            {dateHour.inativo ? <Unblock style={{ marginTop: 15, marginRight: 15, cursor: 'pointer' }} onClick={onBlockHorario} /> : <Block style={{ marginTop: 15, marginRight: 15, cursor: 'pointer' }} onClick={onBlockHorario} />}
                        </Tooltip>
                        <Tooltip title="Excluir">
                            <TrashBin style={{ marginTop: 15, cursor: 'pointer' }} onClick={() => { setShowModalExcluirHorario(true) }} />
                        </Tooltip>
                    </div>
                </div>
            ) : (
                <div style={{ paddingLeft: 10, paddingRight: 10, backgroundColor: dateHour.inativo ? '' : Colors.GRAY50, marginBottom: 10, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex' }}>
                        <Text color={Colors.SPM800} bold style={{ marginRight: 80, opacity: dateHour.inativo ? '0.5' : '' }}>{`Data: ${dateHour.date}`}</Text>
                        <Text color={Colors.SPM800} style={{ opacity: dateHour.inativo ? '0.5' : '' }} bold >{`Intervalo: ${dateHour.horario.horarioInicial} - ${dateHour.horario.horarioFinal}`}</Text>
                        {!dateHour.inativo && onVerAgenda && (
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
                                <Tooltip title={slotListString}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                        <AccessTimeIcon style={{ fontSize: 16, color: Colors.SPM400, marginRight: 4 }} />
                                        <Text style={{ fontSize: 12, color: Colors.GRAY400 }}>{activeSlots.length}</Text>
                                    </div>
                                </Tooltip>
                                <Text color={Colors.SPM600} bold style={{ cursor: 'pointer', fontSize: 14 }} onClick={onVerAgenda}>
                                    VER AGENDA {'>'}
                                </Text>
                            </div>
                        )}
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <Text color={Colors.SPM800} bold>Ações:</Text>
                        <Tooltip title={dateHour.inativo ? 'Desbloquear' : 'Bloquear'}>
                            {dateHour.inativo ? <Unblock style={{ marginTop: 15, marginRight: 15, cursor: 'pointer' }} onClick={onBlockHorario} /> : <Block style={{ marginTop: 15, marginRight: 15, cursor: 'pointer' }} onClick={onBlockHorario} />}
                        </Tooltip>
                        <Tooltip title="Excluir">
                            <TrashBin style={{ marginTop: 15, cursor: 'pointer' }} onClick={() => { setShowModalExcluirHorario(true) }} />
                        </Tooltip>
                    </div>
                </div>
            )}
            <GenericModal 
                    Icon={()=>{ return <TrashBin width={120} height={120} />}}
                    visible={showModalExcluirHorario} 
                    onCancel={()=>{ onConfirmDeleteHorario(); setShowModalExcluirHorario(false); }} 
                    onConfirm={()=>{setShowModalExcluirHorario(false)}} 
                    modalTitle={'Tem certeza que deseja excluir o horário selecionado?'} 
                    modalSubtitle={''} 
                    cancelButtonMsg={'Voltar'} 
                    confirmButtonMsg={'Excluir'}                
                />
        </>
    )
    // --------------------------------------------------------
}

export default AgendaDiaHorarioListItem